import {useStore} from "@/helpers/store-effect";

export default function useNotifications() {
    const store = useStore();

    return {
        notify: store.notifications.add
    };
}
